/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsUpdateParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiAccountsUpdateParams = zod.input<typeof ApiAccountsUpdateParams>;
export type ApiAccountsUpdateParamsOutput = zod.output<
    typeof ApiAccountsUpdateParams
>;
